export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
export const FETCH_CASE_DATA = 'FETCH_CASE_DATA';
export const FETCH_AGE_DEMOGRAPHIC_DATA = 'FETCH_AGE_DEMOGRAPHIC_DATA';
export const FETCH_SEX_DEMOGRAPHIC_DATA = 'FETCH_SEX_DEMOGRAPHIC_DATA';
export const FETCH_ETHNICITY_DEMOGRAPHIC_DATA = 'FETCH_ETHNICITY_DEMOGRAPHIC_DATA';